import React, {useEffect, useState} from 'react'
import styled from '@emotion/styled';

const SearchBarContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    padding: 1.25rem;

    position: relative;
    width: 100%;
    height: 5rem;

    background: white;

    border: 1px solid var(--color-neutral-gray-300);
    box-sizing: border-box;
    border-radius: var(--space-8);

    .category {
    }
    
    .search--bar {
        width: 100%;
        height: 2.5rem;
        
        margin-left: auto;
        padding-left: 1rem;
        padding-right: 1rem;
    
        background: var(--color-neutral-gray-100);
        border: 1px solid var(--color-neutral-gray-400);
        box-sizing: border-box;
        border-radius: var(--space-6);

        background-image: url(/icons/search-icon.svg);
        background-repeat: no-repeat;
        background-position: right 1rem top 50%;
    }

    
    /* .search--bar > .search-icon {
        position: absolute;
        left: 110%;
        right: 0%;
        top: 70%;
        bottom: -0.31%;
    } */
    
    .category--select {
        display: flex;
        align-items: center;
        
        border: none;
        
        font-style: normal;
        font-weight: 500;
        font-size: var(--font-16);
        line-height: var(--font-16);
        background: none;
        margin-right: var(--space-16);
        color: var(--company-dark);
    }
    @media (max-width: 768px){
       /* width:96%;
       align-self:center;
       justify-content:center;
       padding-left: 1rem; */
      
    }
    @media (max-width: 500px){
        width: inherit;
        .category--select{
            display:none;
        }
        .search--bar{
            width:100%;
        }
    }
`;

function SearchBar(props) {
    const {onSearchTextChange, categories, selectedCategory, categoryChange,search,value} = props;

    useEffect(() => {
        // todo: pull from redux
    }, [])

    const check = (val) =>{
        if(value){
            search(val);
        }
        
    }
    
    return (
        <SearchBarContainer onClick={()=>check(false)}>
            <select id='category-select' className='category--select' onChange={categoryChange} value={selectedCategory || ''}>
                <option value=''>All Categories</option>
                {
                    categories.map(category => <option
                            value={category._id}
                            key={category._id}>
                            {category.name}
                        </option>
                    )
                }
            </select>
            {/* <img className='category--chevron' alt='dropdown icon' src='/icons/chevy.svg'></img> */}
            {/* <img src='/icons/search-icon.svg' alt='search icon' className='search-icon'/> */}
            <input
                
                className='search--bar'
                name='productSearch'
                placeholder='Find the items you need...'
                type='text'
                onChange={onSearchTextChange}
            />
        </SearchBarContainer>
    )
}

export default SearchBar
